import React, { useState } from "react";
import PropTypes from "prop-types";
import analytics from "analytics/analytics";
import style from "./ventory-nav-menu.css";
import ProductTypeMenu from "./product-type-menu";
import CategoryMenu from "./category-menu";
import RetailerSelector from "./retailer-selector";
import Header from "./header";
import SlidingView from "./sliding-view";
import { gender, genderShort } from "./constants";


const menu = {
    productType: 0,
    category: 1,
    retailer: 2
};

function VentoryNavMenu({ data, selectedGender, onCloseClick }) {
    const genderedCategoriesData = data.gendered_menus.filter(
        data => data.gender === selectedGender
    )[0].product_types;
    const retailersData = data.retailer_options;
    const [selectedProductType, setSelectedProductType] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [mainMenuIndex, setMainMenuIndex] = useState(menu.productType);
    const [selectedRetailers, setSelectedRetailers] = useState([]);
    const [title, setTitle] = useState(gender === genderShort.men ? gender.men : gender.women);

    const selectedProductTypeData = genderedCategoriesData.filter(productType => {
        return productType.name === selectedProductType;
    })[0];

    return (
        <div className={style.container}>
            <Header
                index={mainMenuIndex}
                onBackClick={onBackClick}
                title={title}
                onCloseClick={onCloseClick}
            />
            <SlidingView index={mainMenuIndex}>
                <ProductTypeMenu
                    genderedCategoriesData={genderedCategoriesData}
                    onProductTypeClick={onProductTypeClick}
                />
                <CategoryMenu
                    selectedProductType={selectedProductType}
                    selectedProductTypeData={selectedProductTypeData}
                    onCategoryClick={onCategoryClick}
                />
                <RetailerSelector
                    selectedGender={selectedGender}
                    selectedProductType={selectedProductType}
                    selectedCategory={selectedCategory}
                    onBackFromRetailerClick={onBackFromRetailerClick}
                    retailersData={retailersData}
                    selectedRetailers={selectedRetailers}
                    setSelectedRetailers={setSelectedRetailers}
                    genderedCategoriesData={genderedCategoriesData}
                />
            </SlidingView>
        </div>
    );

    function onBackClick() {
        switch (mainMenuIndex) {
            // Back from Gender Menu
            case menu.productType:
                break;
            // Back from Category Menu
            case menu.category:
                onBackFromCategoryClick();
                break;
            // Back from Retailer Menu
            case menu.retailer:
                onBackFromRetailerClick();
        }
    }

    function onProductTypeClick(productTypeName) {
        analytics.event("ventory nav", "clicked product type", productTypeName.toLowerCase());
        setTitle(productTypeName);
        setSelectedProductType(productTypeName);
        setMainMenuIndex(menu.category);
    }

    function onCategoryClick(categoryName) {
        analytics.event("ventory nav", "clicked category", categoryName.toLowerCase());
        setTitle(categoryName);
        setSelectedCategory(categoryName);
        setMainMenuIndex(menu.retailer);
    }

    function onBackFromCategoryClick() {
        analytics.event("ventory nav", "clicked back from category");
        setTitle(selectedGender === genderShort.men ? gender.men : gender.women);
        setSelectedProductType(null);
        setMainMenuIndex(menu.productType);
    }

    function onBackFromRetailerClick() {
        analytics.event("ventory nav", "clicked back from retailer");
        setTitle(selectedProductType);
        setSelectedCategory(null);
        setMainMenuIndex(menu.category);
    }
}

export default VentoryNavMenu;

VentoryNavMenu.propTypes = {
    data: PropTypes.object.isRequired,
    selectedGender: PropTypes.oneOf([genderShort.men, genderShort.women]).isRequired,
    onCloseClick: PropTypes.func.isRequired
};
